import { Booking, BookingTemplate, Id } from "PFTypes";
import { Availability } from "PFTypes/booking";
import { useCallback, useState } from "react";

import { Requirement } from "./use_requirement";

export interface ModalBooking extends Omit<Booking, "start_date" | "end_date"> {
  startDate: string;
  endDate: string;
}

export enum BookingModalMode {
  Create = "create",
  Edit = "edit",
  Clone = "clone"
}

export interface BookingModalDataType {
  searchId?: number;
  total?: number;
  entries?: any[];
  profileId?: number;
  startDate?: string;
  endDate?: string;
  title?: string;
  description?: string;
  categoryId?: Id | null;
  bookings?: Partial<ModalBooking>[];
  availability?: Availability | null;
  activityId?: number | null;
  parentActivityId?: number;
  bookingGroupId?: number;
  bookingTemplate?: BookingTemplate;
  shortlistId?: number;
  onSubmit?: () => void;
  overridesCalendar?: boolean;
  overridesNonWorkingDays?: boolean;
  roleBookingsIds?: number[];
}

interface ModalPropsType {
  onSuccess?: () => void;
  bookingId?: number;
  mode?: BookingModalMode;
}

interface ModalDataStateType {
  isOpen: boolean;
  data?: BookingModalDataType;
  props?: ModalPropsType;
}

export type BookingModalType = {
  state: ModalDataStateType;
  open: (data?: BookingModalDataType, props?: ModalPropsType) => void;
  close: () => void;
};

export type IBookingModalItem = {
  start: string;
  end: string;
  startTime?: string;
  endTime?: string;
  requirement: Requirement;
  duration: string;
  state?: string;
  wdayMask?: number;
  phaseSourceId?: string;
};

export const useBookingModal = () => {
  const [modalData, setModalData] = useState<ModalDataStateType>({ isOpen: false });

  const open = useCallback(
    (data: BookingModalDataType, props?: ModalPropsType) => setModalData({ isOpen: true, data, props }),
    []
  );

  const close = useCallback(() => setModalData({ isOpen: false }), []);

  return { open, close, state: modalData };
};
